import { getDicts } from '@/api/system/dict/data.js'
import useDictStore from '@/store/dictStore.js'
import { ref, toRefs } from 'vue'

const readResponseData = (response) => {
  if (Array.isArray(response)) {
    return response
  }
  if (Array.isArray(response?.data)) {
    return response.data
  }
  if (Array.isArray(response?.data?.data)) {
    return response.data.data
  }
  return []
}

const normalizeDictItem = (item) => ({
  label: item.dictLabel ?? item.label ?? '',
  value: item.dictValue ?? item.value ?? '',
  elTagType: item.listClass ?? item.elTagType ?? '',
  elTagClass: item.cssClass ?? item.elTagClass ?? '',
})

export const resolveDictMeta = (options = [], value, fallbackLabel) => {
  const item = options.find((option) => String(option.value) === String(value))
  return {
    label: item?.label || fallbackLabel || value || '-',
    color: item?.elTagType || 'default',
  }
}

export function useDict(...args) {
  const result = ref({})
  const dictStore = useDictStore()

  args.forEach((dictType) => {
    result.value[dictType] = []

    const cachedDict = dictStore.getDict(dictType)
    if (cachedDict) {
      result.value[dictType] = cachedDict
      return
    }

    getDicts(dictType)
      .then((response) => {
        const dictList = readResponseData(response).map(normalizeDictItem)
        result.value[dictType] = dictList
        dictStore.setDict(dictType, dictList)
      })
      .catch(() => {
        result.value[dictType] = []
      })
  })

  return toRefs(result.value)
}
